<template>
  <div>
    <div class="container">
      <div class="px-3">
        <section id="filter">
          <div class="row mt-2">
            <div class="col-4">
              <input
                placeholder="Mulai Tgl. Registrasi"
                class="form-control m-2"
                :type="filterRegisStart"
                @focus="filterRegisStart = 'date'"
                @blur="filter.registrationdateStart == '' ? (filterRegisStart = 'text') : (filterRegisStart = 'date')"
                id="date"
                v-model="filter.registrationdateStart"
              />
            </div>
            <div class="col-4">
              <input
                placeholder="Akhir Tgl. Registrasi"
                class="form-control m-2"
                :type="filterRegisEnd"
                @focus="filterRegisEnd = 'date'"
                @blur="filter.registrationdateEnd == '' ? (filterRegisEnd = 'text') : (filterRegisEnd = 'date')"
                id="date"
                v-model="filter.registrationdateEnd"
              />
            </div>
            <div class="col-4">
              <input
                placeholder="QR Code"
                class="form-control m-2"
                type="text"
                list="qrcode"
                v-model="filter.qrcodeid"
                @keyup="getDataQR($event)"
              />
              <datalist id="qrcode">
                <option v-for="(station, index) in dataQr" :key="index">
                  {{ station.data }}
                </option>
              </datalist>
            </div>
            <div class="col-4">
              <select
                class="form-select m-2"
                v-model="filter.client"
                :class="filter.client ? '' : 'text-secondary'"
              >
                <option value="" selected>
                  {{ filter.client ? "none" : "Client" }}
                </option>
                <option
                  v-for="client in dataClient.content"
                  :key="client.id"
                  class="text-dark"
                  :value="client.id"
                >
                  {{ client.name }}
                </option>
              </select>
            </div>
            <div class="col-4">
              <input
                placeholder="Batch"
                class="form-control m-2"
                type="text"
                list="batch"
                v-model="filter.batch"
                @keyup="getDataBatch($event)"
              />
              <datalist id="batch">
                <option v-for="(batch, index) in dataBatch" :key="index">
                  {{ batch.batch }}
                </option>
              </datalist>
            </div>
            <div class="col-4">
              <input
                placeholder="Tgl. Online"
                class="form-control m-2"
                :type="filterTglOnline"
                @focus="(filterTglOnline='date')"
                @blur="(filter.tanggalonline == '' ?filterTglOnline='text' :filterTglOnline='date')"
                id="date"
                v-model="filter.tanggalonline"
              />
            </div>
            <div class="col-4">
              <input
                placeholder="Station"
                class="form-control m-2"
                type="text"
                v-model="filter.station"
                list="station"
                @keyup="getDataStation($event)"
              />
              <datalist id="station">
                <option v-for="(station, index) in dataStation" :key="index">
                  {{ station.station }}
                </option>
              </datalist>
            </div>
            <div class="col-4">
              <input
                placeholder="MTS"
                class="form-control m-2"
                type="text"
                v-model="filter.mts"
                list="Mts"
                @keyup="getDataMts($event)"
              />
              <datalist id="Mts">
                <option v-for="(mts, index) in dataMts" :key="index">
                  {{ mts.mts }}
                </option>
              </datalist>
            </div>
            <div class="col-4">
              <button
                @click="getDataLaporan('0')"
                class="btn btn-success rounded-pill shadow text-white mx-2"
              >
                <i class="fa fa-search"></i>
              </button>
              <button
                @click="refresh()"
                class="btn btn-success rounded-pill shadow text-white mx-2"
              >
                <i class="fa fa-refresh"></i>
              </button>
            </div>
          </div>
        </section>
      </div>
      <div class="p-3">
        <section id="table">
          <table-laporan
            :data-table="dataLaporan"
            :current-page="currentPage"
            :data-length="dataLength"
            :page-length="pageLength"
            :offset="offset"
            :size="size"
            @download-laporan="downloadLaporan()"
          >
            <template #button>
              <paginate
                v-model="pagination"
                :page-count="pageLength"
                :page-range="5"
                :margin-pages="1"
                :click-handler="movePage"
                :prev-text="'<'"
                :next-text="'>'"
                :container-class="'pagination'"
                :page-class="'page-item'"
                :first-last-button="true"
                first-button-text="<<"
                last-button-text=">>"
              />
            </template>
          </table-laporan>
        </section>
      </div>
    </div>

    <modal modalName="modalLoading" :isFooter="false" :isHeader="false">
      <template #body>
        <div class="text-center">
          <span>
            <h2 class="fs-5">
              {{ store.state.isLoading ? "Menunggu Proses Download" : "Selesai !" }}
            </h2>
            <argon-progress :percentage="percentage" variant="gradient" color="success" />
            <p v-show="!processFailed" class="fs-5">{{ percentage }}%</p>
            <p v-show="processFailed" class="fs-5 text-danger">Proses Gagal !</p>
            <button
              v-show="!store.state.isLoading"
              class="btn btn-success mt-4"
              data-bs-dismiss="modal"
              @click="processFailed = false"
            >
              Ok
            </button>
          </span>
        </div>
      </template>
    </modal>
  </div>
</template>

<script setup>
import { ref, computed } from "@vue/reactivity";
import { onMounted } from "@vue/runtime-core";
import { ApiService } from "@/axios/apiService";
import { useStore } from "vuex";
import TableLaporan from "../components/laporan/TableLaporan.vue";
import Modal from "@/components/ModalComponent.vue";
import Paginate from "vuejs-paginate-next";
import ArgonProgress from "@/components/ArgonProgress.vue";

//data
const store = useStore();
const apiService = new ApiService();
const dataLaporan = ref([]);
const filter = ref({
  registrationdateStart: "",
  registrationdateEnd: "",
  qrcodeid: "",
  batch: "",
  tanggalonline: "",
  station: "",
  mts: "",
  client: "",
});
const dataQr = ref([]);
const dataBatch = ref([]);
const dataStation = ref([]);
const dataMts = ref([]);
const currentPage = ref(0);
const dataLength = ref(0);
const pageLength = ref(0);
const processFailed = ref(false);
const offset = computed(() => 10 * currentPage.value);
const size = ref(10);
const pagination = computed(() => currentPage.value + 1);
const percentage = ref(0);
const dataClient = ref([]);
const filterRegisStart = ref("text");
const filterRegisEnd = ref("text");
const filterTglOnline = ref("text");

//methods
const getDataPelanggan = async () => {
  const res = await apiService.getPelanggan(10, 0);
  dataClient.value = res.data;
};

const getDataLaporan = async (page) => {
  try {
    store.state.isLoading = true;
    filterMove = { ...filter.value };
    currentPage.value = page;
    const res = await apiService.getLaporan(page, filter.value);
    dataLaporan.value = res.data.content;
    dataLength.value = res.data.totalElements;
    pageLength.value = res.data.totalPages;
    store.state.isLoading = false;
  } catch (error) {
    console.log(error);
    store.state.isLoading = false;
  }
};

let filterMove = {};
const movePage = async (pageNumber) => {
  store.state.isLoading = true;
  currentPage.value = pageNumber - 1;
  const res = await apiService.getLaporan(currentPage.value, filterMove);
  dataLaporan.value = res.data.content;
  dataLength.value = res.data.totalElements;
  pageLength.value = res.data.totalPages;
  store.state.isLoading = false;
};

const refresh = async () => {
  filter.value = {
    registrationdateStart: "",
    registrationdateEnd: "",
    qrcodeid: "",
    batch: "",
    tanggalonline: "",
    station: "",
    mts: "",
    client: "",
  };
  currentPage.value = 0;
  filterRegisEnd.value = "text";
  filterRegisStart.value = "text";
  await getDataLaporan(currentPage.value);
};

const downloadLaporan = async () => {
  const data = filter.value;
  if (
    data.registrationdateStart === "" &&
    data.registrationdateEnd === "" &&
    data.qrcodeid === "" &&
    data.batch === "" &&
    data.tanggalonline === "" &&
    data.station === "" &&
    data.client === "" &&
    data.mts === ""
  ) {
    store.dispatch("swalErrorDownload");
  } else {
    try {
      store.state.isLoading = true;
      const link = document.createElement("button");
      link.type = "button";
      link.setAttribute("data-bs-toggle", "modal");
      link.setAttribute("data-bs-target", "#modalLoading");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      percentage.value = 80;
      const response = await apiService.exportExcelLaporan("", "", filter.value);
      const href = URL.createObjectURL(response.data);
      const link1 = document.createElement("a");
      link1.href = href;
      const filename = `Laporan.xls`;
      link1.setAttribute("download", filename); //or any other extension
      document.body.appendChild(link1);
      link1.click();
      document.body.removeChild(link1);
      percentage.value = 100;
      URL.revokeObjectURL(href);
    } catch (error) {
      console.log(error);
      processFailed.value = true;
      store.state.isLoading = false;
    }
    store.state.isLoading = false;
  }
};

let timeoutIdMts;
const getDataMts = async (e) => {
  try {
    if (timeoutIdMts) {
      clearTimeout(timeoutIdMts);
    }
    const data = filter.value.mts;
    if (data && data.length > 2 && e.keyCode !== 8) {
      timeoutIdMts = setTimeout(async () => {
        const res = await apiService.getMts(data);
        dataMts.value = res.data;
      }, 500);
    }
  } catch (error) {
    console.log(error);
  }
};

let timeoutIdBatch;
const getDataBatch = async (e) => {
  try {
    if (timeoutIdBatch) {
      clearTimeout(timeoutIdBatch);
    }
    const data = filter.value.batch;
    if (data && data.length > 2 && e.keyCode !== 8) {
      timeoutIdBatch = setTimeout(async () => {
        const res = await apiService.getBatch(data);
        dataBatch.value = res.data;
      }, 500);
    }
  } catch (error) {
    console.log(error);
  }
};

let timeoutIdStation;
const getDataStation = async (e) => {
  try {
    if (timeoutIdStation) {
      clearTimeout(timeoutIdStation);
    }
    const data = filter.value.station;
    if (data && data.length > 2 && e.keyCode !== 8) {
      timeoutIdStation = setTimeout(async () => {
        const res = await apiService.getStation(data);
        dataStation.value = res.data;
      }, 500);
    }
  } catch (error) {
    console.log(error);
  }
};

let timeoutIdQR;
const getDataQR = async (e) => {
  try {
    if (timeoutIdQR) {
      clearTimeout(timeoutIdQR);
    }
    const data = filter.value.qrcode;
    if (data && data.length > 2 && e.keyCode !== 8) {
      timeoutIdQR = setTimeout(async () => {
        const res = await apiService.getQrCodePostel(data);
        dataQr.value = res.data;
      }, 500);
    }
  } catch (error) {
    console.log(error);
  }
};

onMounted(async () => {
  await getDataLaporan(currentPage.value);
  await getDataPelanggan();
});
</script>
